// Input-level meter (PRD 001 F1) — lets the facilitator confirm the room mic is
// hot before starting. RMS is scaled up (speech rarely tops ~0.3) and capped.

export function LevelMeter({ level }: { level: number }) {
  const pct = Math.min(100, Math.round(level * 300))
  return (
    <div
      className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
      role="meter"
      aria-label="Microphone input level"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-full bg-accent transition-[width] duration-100"
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
